import React from 'react';
import { createElementKey } from 'utils';
import { Section } from '../section';
import { SectionSubTitle } from '../section-subtitle';
import { Step, StepStructure } from './step';
import { StepGrid } from './step-grid';

export type StepsSectionProps = {
  sectionTitle: string;
  steps: StepStructure[];
};

export const StepsSection: React.FC<StepsSectionProps> = ({ sectionTitle, steps }) => (
  <Section>
    <SectionSubTitle margin="m">{sectionTitle}</SectionSubTitle>
    <StepGrid stepNumber={steps.length}>
      {steps.map(({ title, description }: StepStructure, index: number) => (
        <Step
          description={description}
          number={index + 1}
          key={createElementKey('step', index)}
          title={title}
        />
      ))}
    </StepGrid>
  </Section>
);
